var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartBarHorizon } from '../svg-elements/module';
import { breakpoints } from "../_styleguide/_breakpoints";
import { flattenColumn, thousands } from '../d3-services/_helpers';
import { filterWeeks, getNeededColumnsForHistoryV2 } from '../d3-services/data-with-history.functions';
import { GraphControllerV2 } from './graph-v2';
var TickerHorizon = /** @class */ (function (_super) {
    __extends(TickerHorizon, _super);
    function TickerHorizon(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    TickerHorizon.prototype.pre = function () {
        this._addScale("x", "linear", "horizontal", "_week");
        this._addScale("y", "linear", "vertical-reverse", flattenColumn(this.firstMapping['column']));
        this._addMargin(0, 0, 0, 0);
        this._addPadding(0, 4, 0, 0);
        this.parameters.y2 = flattenColumn(this.mapping.parameters[0][1].column);
    };
    TickerHorizon.prototype.init = function () {
        var self = this;
        this._init();
        this.styleMainElement();
        var graphWidth; //  = '142px';
        if (window.innerWidth < breakpoints.sm) {
            graphWidth = '162px';
        }
        else if (window.innerWidth < breakpoints.sm) {
            graphWidth = '142px';
        }
        else if (window.innerWidth < breakpoints.md) {
            graphWidth = '162px';
        }
        else if (window.innerWidth < breakpoints.bax) {
            graphWidth = '112px';
        }
        else {
            graphWidth = '142px';
        }
        var numberContainer = document.createElement('div');
        numberContainer.style.display = 'flex';
        numberContainer.style.flexDirection = 'column';
        numberContainer.style.alignItems = 'flex-start';
        numberContainer.style.width = 'calc(100% - ' + graphWidth + ' - 1.25rem)';
        numberContainer.style.marginTop = '-1.25rem';
        var label = document.createElement('div');
        label.innerText = this.mapping.parameters[1][0].label;
        numberContainer.appendChild(label);
        var number = document.createElement('div');
        number.innerText = thousands(this.data[0][flattenColumn(this.mapping.parameters[1][0].column)]);
        number.style.fontSize = '2.5rem';
        number.style.lineHeight = "1.05";
        number.style.fontFamily = "Replica";
        numberContainer.appendChild(number);
        var units = document.createElement('div');
        units.innerText = this.mapping.parameters[1][0].units;
        numberContainer.appendChild(units);
        this.element.appendChild(numberContainer);
        var graphContainer = document.createElement('div');
        graphContainer.style.width = graphWidth;
        graphContainer.style.height = '5rem';
        graphContainer.style.marginRight = '1.25rem';
        graphContainer.style.paddingTop = '.25rem';
        this.element.appendChild(graphContainer);
        this._svg(graphContainer);
        this.chartBars = new ChartBarHorizon(this);
        this.update(this.data, this.segment, false);
    };
    TickerHorizon.prototype.styleMainElement = function () {
        this.element.style.position = 'relative';
        this.element.style.display = 'flex';
        this.element.style.flexDirection = 'row-reverse';
        this.element.style.flexWrap = 'wrap';
        this.element.style.justifyContent = 'center';
        this.element.style.padding = '1rem 0';
        this.element.style.margin = 'auto';
        if (window.innerWidth < breakpoints.sm) {
            this.element.style.width = '100%';
            this.element.style.margin = '1.5rem auto';
        }
        else if (window.innerWidth < breakpoints.md) {
            this.element.style.flex = '0 0 50%';
            this.element.style.margin = '2rem auto 0 auto';
            this.element.style.height = '100%';
        }
        else {
            this.element.style.flex = 'auto';
            this.element.style.height = '100%';
            this.element.style.width = '298px';
        }
    };
    TickerHorizon.prototype.prepareData = function (data) {
        var _this = this;
        var neededColumns = getNeededColumnsForHistoryV2(data, this.mapping).concat(this.mapping.parameters[1][0].column);
        var history = filterWeeks(data, neededColumns);
        var voorraad_bij_eind = history[0][flattenColumn(this.mapping.parameters[1][0].column)];
        history.forEach(function (week) {
            week['diff'] = week[_this.parameters.y] - week[_this.parameters.y2];
            week['relative_diff'] = voorraad_bij_eind - week[flattenColumn(_this.mapping.parameters[1][0].column)];
        });
        return {
            "history": history.slice(0, history.length),
            "latest": data[0],
            "slice": history.slice(0, 20).reverse(),
            "average": this.average(history)
        };
    };
    TickerHorizon.prototype.redraw = function (data) {
        var _this = this;
        var yValues = data.slice.map(function (d) { return d[_this.parameters.y]; }).concat(data.slice.map(function (d) { return d[_this.y2Parameter]; }));
        this.yScale = this.scales.y.set(yValues);
        _super.prototype.redraw.call(this, data);
        this.yScale = this.scales.y.reset('vertical-reverse', this.dimensions, this.yScale);
        this.chartBars.redraw(data);
    };
    TickerHorizon.prototype.draw = function (data) {
        var _this = this;
        var xValues = data.slice.map(function (d) { return d[_this.parameters.x]; });
        this.scales.x.set([xValues[xValues.length - 1]], xValues[0]);
        this.chartBars.draw(data);
    };
    TickerHorizon.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    TickerHorizon.prototype.average = function (data) {
        var _this = this;
        data = data.filter(function (d) { return d[_this.parameters.y] > 0; });
        return (data.reduce(function (a, b) { return a + parseInt(b[_this.parameters.y]); }, 0)) / (data.length);
    };
    return TickerHorizon;
}(GraphControllerV2));
export default TickerHorizon;
